import type { GroupTransform, PageShape } from "@pdfking/renderer-api"
import { GroupMatrix, PlotFunction } from "@pdfking/renderer-api"

/** `shapes` turned `rotation` counter-clockwise about `origin` and moved by
 * `translate`, as one group; straight back when that moves nothing. How a list
 * of shapes drawn upright gets onto something that stands turned. */
export const CreateGroup = (
  shapes: PageShape[],
  transform: Pick<GroupTransform, "origin" | "rotation" | "translate">
): PageShape[] =>
  !shapes.length || (!transform.rotation && !transform.translate?.x && !transform.translate?.y)
    ? shapes
    : [{ enum: PlotFunction.PLOT_GROUP, matrix: GroupMatrix(transform), shapes }]
